import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitCustomZoneModel } from '@apps-common/types/portal/unit'

export const updateUnitCustomZone = async (model: IUnitCustomZoneModel): Promise<IUnitCustomZoneModel> =>
  axios.post(`/my-monitoring/sites/UpdateZone`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitCustomZoneModel
}

export const useMyMonitoringUpdateSiteZone = (notify?: boolean, onSuccess?: (data: IUnitCustomZoneModel) => void) =>
  useMutation({
    mutationKey: ['updateMyMonitoringSiteZone'],
    mutationFn: ({ model }: Props) => updateUnitCustomZone(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Zone updated.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to update zone, please try again.')
      }
    },
    throwOnError: false
  })
